import service from '@/store/services/workshop/faktur-service';

const state = {
  list: {},
  faktur: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, faktur) => {
    state.faktur = faktur;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((faktur) => { commit('SET_RESOURCE', faktur); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((faktur) => { commit('SET_RESOURCE', faktur); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((faktur) => { commit('SET_RESOURCE', faktur); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((faktur) => { commit('SET_RESOURCE', faktur); });
  },

  // faktur_date({commit, dispatch}, params) {
  //   return service.faktur_date(params)
  //   .then(({list, meta}) => {
  //     commit('SET_LIST', list);
  //     commit('SET_META', meta);
  //   });
  // },

  faktur_date({commit, dispatch}, params) {
    return service.faktur_date(params)
      .then((faktur) => { commit('SET_RESOURCE', faktur); });
  },

}; 

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  faktur: state => state.faktur,
  page: state => state.meta.page,
};
 
const faktur = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default faktur;
